function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9227 0.1465C16.7274 -0.0487916 16.4109 -0.0488394 16.2156 0.146393C16.0203 0.341626 16.0202 0.658208 16.2155 0.8535C17.9964 2.63501 18.9969 5.05094 18.9969 7.57C18.9969 10.0891 17.9964 12.505 16.2155 14.2865C16.0202 14.4818 16.0203 14.7984 16.2156 14.9936C16.4109 15.1888 16.7274 15.1888 16.9227 14.9935C18.8911 13.0245 19.9969 10.3542 19.9969 7.57C19.9969 4.78578 18.8911 2.11554 16.9227 0.1465Z",
  fill: "#BABABA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3927 3.6765C13.1974 3.48121 12.8809 3.48116 12.6856 3.67639C12.4903 3.87163 12.4902 4.18821 12.6855 4.3835C13.5291 5.22738 14.003 6.37176 14.003 7.565C14.003 8.75824 13.5291 9.90263 12.6855 10.7465C12.4902 10.9418 12.4903 11.2584 12.6856 11.4536C12.8809 11.6488 13.1974 11.6488 13.3927 11.4535C14.4238 10.4221 15.003 9.0234 15.003 7.565C15.003 6.1066 14.4238 4.7079 13.3927 3.6765Z",
  fill: "#BABABA"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 0.570007C10 0.377805 9.88983 0.202616 9.71659 0.119356C9.54336 0.0360958 9.33774 0.0595049 9.18765 0.179573L4.32461 4.07001H0.5C0.223858 4.07001 0 4.29387 0 4.57001V10.57C0 10.8461 0.223858 11.07 0.5 11.07H4.32461L9.18765 14.9604C9.33774 15.0805 9.54336 15.1039 9.71659 15.0207C9.88983 14.9374 10 14.7622 10 14.57V0.570007ZM4.81235 4.96044L9 1.61032V13.5297L4.81235 10.1796C4.72369 10.1086 4.61354 10.07 4.5 10.07H1V5.07001H4.5C4.61354 5.07001 4.72369 5.03137 4.81235 4.96044Z",
  fill: "#BABABA"
});

var SvgIconVolumeHigh = function SvgIconVolumeHigh(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconVolumeHigh, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_volume_high.8e3c82f2.svg";
export { ForwardRef as ReactComponent };